/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { Modal, Button } from "react-bootstrap";
import { get } from "../Network/requests";
import { tokenExpire } from "../Utils";
import { getUrl } from "../Network/urls";
import Loader from "./UI/Loader";
import AppContext from "../Store/AppContext";

function FileDownloadModal({
  show,
  onHide,
  onDownload,
  productCode,
  regulationCode,
  operation,
  source,
}) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const link = document.createElement("a");
  const {
    handleEncryptOtherParamsOfAPI,
    encryptedClientValuesObj,
    clientDetails,
    handleDecryptResponse,
    handleAPIEncryptValue,
  } = useContext(AppContext);
  const handleOnClick = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const url = getUrl("file-download");
    const paramsObj = {
      productCode,
      onDownload,
      regulationCode,
      source,
      operation,
    };
    const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
    const data = {
      file_name: encryptedParamsObj.onDownload,
      client_id: encryptedClientValuesObj.clientId,
      product: encryptedParamsObj.productCode,
      regulation: encryptedParamsObj.regulationCode,
      email_id: clientDetails.email,
      operation: encryptedParamsObj.operation,
      source: encryptedParamsObj.source,
    };
    const regdataData = handleAPIEncryptValue(JSON.stringify(data));
    // get(`${url}?s3path=${onDownload}`, true)
    get(`${url}?regdata=${regdataData}`, true)
      .then((response) => {
        const {
          data: { encryptBody, statusCode, authData },
        } = response;
        let fileName = onDownload.split("/").slice(-1)[0];
        setIsLoading(false);
        switch (statusCode) {
          case 200:
            const iv = authData;
            const idToken = localStorage.getItem("userToken");
            const secretKey = idToken.slice(998, 1030);
            const body = handleDecryptResponse(
              encryptBody.toString(),
              secretKey.toString(),
              iv.toString()
            );
            onHide();
            if (fileName.indexOf(".xml") > -1) {
              get(body.SignedURL).then((res) => {
                let xmlText = res.data;
                let bb = new Blob([xmlText], { type: "text/plain" });
                link.setAttribute("href", window.URL.createObjectURL(bb));
                link.setAttribute("download", fileName);
                link.dataset.downloadurl = [
                  "text/plain",
                  link.download,
                  link.href,
                ].join(":");
                link.draggable = true;
                link.classList.add("dragout");
                link.click();
                toast.success("File downloaded successfully.");
              });
            } else {
              link.href = `${body.SignedURL}`;
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              toast.success("File downloaded successfully.");
            }
            break;
          case 400:
            toast.error("Error fetching the file.");
            break;
          case 401:
            toast.error("Unauthorized Access");
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      })
      .catch((error) => {
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        setIsLoading(false);
      });
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          show={show}
          backdropClassName="custom-modal-backdrop p-0"
          dialogClassName="custom-modal-dialog"
          style={{ zIndex: 999999, padding: 0 }}
          onHide={() => onHide()}
          centered
        >
          <Modal.Body>
            <h6>Do you want to download the file?</h6>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => onHide()}>No</Button>
            <Button onClick={(e) => handleOnClick(e)}>Yes</Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}

export default FileDownloadModal;
